import usegetdata from '../../Hooks/useGetData';
import { useinsertdatawithoutimage } from '../../Hooks/usePostData';
import {
  AddMeetingComment_Type,
  Get_All_Leads_For_Managers_By_Managers_Email,
  Get_All_Leads_For_Managers_By_Managers_Email_CRM_DATA,
  Get_All_Leads_For_Role_By_email_Type,
  Get_All_Leads_For_TeamLeader_By_TeamLeader_Email,
  Get_All_Sales_Managers_By_Email,
  Get_All_Team_Leaders,
  Get_Error,
  Get_sales_dashboard_Advanced,
  Get_TeamLeader_Dashboard_Advanced_crmdata_Type,
  Get_TeamLeader_Dashboard_Advanced_Type,
} from '../Types';

// get all team leader
export const Getall_data_user_log_teamleaders = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Signup?role=Team Leader&role=Manager&role=Admin`);

    dispatch({
      type: Get_All_Team_Leaders,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};

//get all data SAles with email from Sales userlog Field action

export const GetallLeads_data_With_Email =
  (email, query = '') =>
  async (dispatch) => {
    try {
      const res = await usegetdata(`api/v1/users/filter-by-email?email=${email}${query}`);

      dispatch({
        type: Get_All_Leads_For_Role_By_email_Type,
        payload: res,
      });
    } catch (e) {
      dispatch({
        type: Get_Error,
        payload: e + 'error',
      });
    }
  };

// /get teamleader dashboard data
export const Getteamleaderdashboarddatabyteamleaderemailadvanced = (email) => async (dispatch) => {
  console.log('🚀 Action started with email:', email);
  console.log(
    '📝 Get_TeamLeader_Dashboard_Advanced_Type value:',
    Get_TeamLeader_Dashboard_Advanced_Type,
  );

  try {
    console.log('📡 Calling API with URL:', `api/v1/users/teamleader/dashboard-cached2/${email}`);

    // تحقق من usegetdata function
    console.log('🔧 usegetdata function exists:', typeof usegetdata);

    const res = await usegetdata(`api/v1/users/teamleader/dashboard-cached2/${email}`);

    console.log('✅ API Response received:', res);
    console.log('📊 Response data structure:', {
      hasData: !!res,
      isSuccess: res?.success,
      data: res?.data,
      status: res?.status,
      fullResponse: res,
    });

    if (res?.success) {
      console.log('🎯 Success! Data summary:', {
        totalLeads: res.data?.summary?.totalLeads,
        stagesCount: res.data?.dashboard?.length,
        teamLeaderFresh: res.data?.teamLeaderFresh?.leadsCount,
        teamLeaderPending: res.data?.teamLeaderPending?.leadsCount,
      });
    } else {
      console.warn('⚠️ Response success is false:', res);
    }

    dispatch({
      type: Get_TeamLeader_Dashboard_Advanced_Type,
      payload: res,
    });

    console.log('✅ Dispatch completed with type:', Get_TeamLeader_Dashboard_Advanced_Type);

    return res;
  } catch (e) {
    console.error('❌ Error caught in action:', e);
    console.error('❌ Error name:', e.name);
    console.error('❌ Error message:', e.message);
    console.error('❌ Error stack:', e.stack);

    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });

    console.log('✅ Error dispatch completed');

    throw e;
  }
};

// team leader dashboard crm data
export const GetteamleaderdashboarddatabyteamleaderemailadvancedCRMDATA =
  (email) => async (dispatch) => {
    console.log('🚀 Action started with email:', email);
    console.log(
      '📝 Get_TeamLeader_Dashboard_Advanced_Type value:',
      Get_TeamLeader_Dashboard_Advanced_crmdata_Type,
    );

    try {
      console.log(
        '📡 Calling API with URL:',
        `api/v1/users/teamleader/dashboard-cached2-CRMDATA/${email}`,
      );

      // تحقق من usegetdata function
      console.log('🔧 usegetdata function exists:', typeof usegetdata);

      const res = await usegetdata(`api/v1/users/teamleader/dashboard-cached2-CRMDATA/${email}`);

      console.log('✅ API Response received:', res);
      console.log('📊 Response data structure:', {
        hasData: !!res,
        isSuccess: res?.success,
        data: res?.data,
        status: res?.status,
        fullResponse: res,
      });

      if (res?.success) {
        console.log('🎯 Success! Data summary:', {
          totalLeads: res.data?.summary?.totalLeads,
          stagesCount: res.data?.dashboard?.length,
          teamLeaderFresh: res.data?.teamLeaderFresh?.leadsCount,
          teamLeaderPending: res.data?.teamLeaderPending?.leadsCount,
        });
      } else {
        console.warn('⚠️ Response success is false:', res);
      }

      dispatch({
        type: Get_TeamLeader_Dashboard_Advanced_crmdata_Type,
        payload: res,
      });

      console.log(
        '✅ Dispatch completed with type:',
        Get_TeamLeader_Dashboard_Advanced_crmdata_Type,
      );

      return res;
    } catch (e) {
      console.error('❌ Error caught in action:', e);
      console.error('❌ Error name:', e.name);
      console.error('❌ Error message:', e.message);
      console.error('❌ Error stack:', e.stack);

      dispatch({
        type: Get_Error,
        payload: e + 'error',
      });

      console.log('✅ Error dispatch completed');

      throw e;
    }
  };

// sales dashboard advanced
export const get_sales_dashboard_advanced = (email) => async (dispatch) => {
  try {
    const res = await usegetdata(`api/v1/users/sales/dashboard/fast/${email}`);
    dispatch({
      type: Get_sales_dashboard_Advanced,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};

// sales dashboard advanced CRM DAta
export const get_sales_dashboard_advanced_CRM_DATA = (email) => async (dispatch) => {
  try {
    const res = await usegetdata(`api/v1/users/sales/dashboard/fast/CRMDATA/${email}`);
    dispatch({
      type: Get_sales_dashboard_Advanced,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};

export const GetallLeads_data_With_Email2 = (email, query) => async (dispatch) => {
  try {
    // تنظيف الـ query من معلمة email إذا كانت موجودة
    let cleanQuery = query || '';

    // إزالة أي معلمة email من query string
    if (cleanQuery.includes('email=')) {
      const queryParams = new URLSearchParams(cleanQuery);
      queryParams.delete('email');
      cleanQuery = queryParams.toString();
    }

    // بناء الـ URL الصحيح
    let url = `api/v1/users/filter-by-email-advanced?email=${encodeURIComponent(email)}`;

    // إضافة الـ query إذا كان موجوداً
    if (cleanQuery && cleanQuery.trim() !== '') {
      url += `&${cleanQuery}`;
    }

    console.log('🌐 API Request URL:', url);

    const res = await usegetdata(url);

    console.log('✅ API Response:', res);

    dispatch({
      type: Get_All_Leads_For_Role_By_email_Type,
      payload: res,
    });
  } catch (e) {
    console.error('❌ API Error:', e);
    dispatch({
      type: Get_Error,
      payload: e.message + ' error',
    });
  }
};

// leads for sales with email from Sales userlog Field action
// export const GetallLeads_data_With_Email2 = (email, query = "") => async (dispatch) => {
//     try {
//         console.log("🚀 START GetallLeads_data_With_Email2 Action");
//         console.log("📧 Email:", email);
//         console.log("🔍 Query String:", query);

//         // 🔥 بناء الـ URL بشكل صحيح
//         let url = `/api/v1/users/filter-by-email-advanced?email=${encodeURIComponent(email)}`;

//         // 🔥 إضافة الـ query parameters إذا كانت موجودة
//         if (query && query.trim() !== "") {
//             // إذا كانت query تحتوي على ? نزيلها
//             let cleanQuery = query.trim();
//             if (cleanQuery.startsWith("?")) {
//                 cleanQuery = cleanQuery.substring(1);
//             }

//             // إضافة & إذا لم يكن هناك ? في الـ URL
//             if (!url.includes("?")) {
//                 url += "?";
//             } else {
//                 url += "&";
//             }

//             url += cleanQuery;
//         }

//         console.log("🔗 Final URL:", url);
//         console.log("⏰ Making API call at:", new Date().toISOString());

//         // 🔥 استدعاء الـ API
//         const res = await usegetdata(url);

//         console.log("✅ API Response Received");
//         console.log("📊 Response Structure:", Object.keys(res));
//         console.log("🎯 Response Success:", res.success);
//         console.log("📈 Results Count:", res.results || 0);

//         // 🔥 التحقق من وجود البيانات
//         if (res.success) {
//             console.log("👤 Sales Info Found:", {
//                 name: res.salesInfo?.name,
//                 email: res.salesInfo?.email,
//                 totalLeads: res.salesInfo?.totalLeads
//             });

//             console.log("📄 Pagination Info:", {
//                 currentPage: res.pagination?.currentPage,
//                 totalPages: res.pagination?.NumberOfPages,
//                 totalItems: res.pagination?.totalItems,
//                 next: res.pagination?.next,
//                 prev: res.pagination?.prev
//             });

//             // 🔥 التحقق من البيانات المختلفة
//             if (res.data && Array.isArray(res.data)) {
//                 console.log(`✅ Data array found with ${res.data.length} items`);
//             } else if (res.leads && Array.isArray(res.leads)) {
//                 console.log(`✅ Leads array found with ${res.leads.length} items`);
//                 // نسخ leads إلى data للتوافق
//                 res.data = res.leads;
//             } else if (res.users && Array.isArray(res.users)) {
//                 console.log(`✅ Users array found with ${res.users.length} items`);
//                 res.data = res.users;
//             } else {
//                 console.warn("⚠️ No data array found in response");
//                 res.data = [];
//             }

//             // 🔥 إضافة pagination افتراضي إذا لم يكن موجوداً
//             if (!res.pagination) {
//                 console.warn("⚠️ No pagination found, creating default");
//                 res.pagination = {
//                     currentPage: 1,
//                     limit: 10,
//                     NumberOfPages: 1,
//                     totalItems: res.data?.length || 0,
//                     totalAllLeads: res.data?.length || 0,
//                     totalLeadsActive: res.data?.length || 0,
//                     totalLeadsInactive: 0,
//                     next: null,
//                     prev: null
//                 };
//             }

//             console.log(`📦 Final data count: ${res.data?.length || 0}`);

//         } else {
//             console.error("❌ API returned error:", res.message || res.error);
//         }

//         // 🔥 dispatch النتيجة
//         console.log("📤 Dispatching to Redux...");
//         dispatch({
//             type: Get_All_Leads_For_Role_By_email_Type,
//             payload: res,
//         });

//         console.log("✅ Action completed successfully");

//         return res;

//     } catch (error) {
//         console.error("❌ ERROR in GetallLeads_data_With_Email2:", error.message);

//         // 🔥 إنشاء response خطأ
//         const errorResponse = {
//             success: false,
//             error: error.message,
//             requestedEmail: email,
//             data: [],
//             pagination: {
//                 currentPage: 1,
//                 limit: 10,
//                 NumberOfPages: 1,
//                 totalItems: 0,
//                 totalAllLeads: 0,
//                 totalLeadsActive: 0,
//                 totalLeadsInactive: 0,
//                 next: null,
//                 prev: null
//             }
//         };

//         dispatch({
//             type: Get_Error,
//             payload: error.message || "حدث خطأ في جلب البيانات",
//         });

//         return errorResponse;
//     }
// };

//get all data Team Leader with Team Leader email from Sales TeamLeader Field action

export const GetallLeads_data_By_TeamLeader_Email =
  (email, query = '') =>
  async (dispatch) => {
    try {
      const res = await usegetdata(
        `/api/v1/users/teamleader-leads?leadisactive=true&email=${email}${query}`,
      );
      dispatch({
        type: Get_All_Leads_For_TeamLeader_By_TeamLeader_Email,
        payload: res,
      });
    } catch (e) {
      dispatch({
        type: Get_Error,
        payload: e + 'error',
      });
    }
  };

export const GetallLeads_data_With_Emailandpagination_ForTeamLeader =
  (email, query) => async (dispatch) => {
    try {
      // تنظيف الـ query من معلمة email إذا كانت موجودة
      let cleanQuery = query || '';

      // إزالة أي معلمة email من query string
      if (cleanQuery.includes('email=')) {
        const queryParams = new URLSearchParams(cleanQuery);
        queryParams.delete('email');
        cleanQuery = queryParams.toString();
      }

      // 🔥 التعديل هنا: استخدم الرابط الصحيح بدون /users الزيادة
      let url = `api/v1/users/teamleader-leads-withpagination?email=${encodeURIComponent(email)}`;

      // إضافة الـ query إذا كان موجوداً
      if (cleanQuery && cleanQuery.trim() !== '') {
        url += `&${cleanQuery}`;
      }

      console.log('🌐 API Request URL:', url);
      console.log('📧 Email being sent:', email);
      console.log('🔍 Full request details:', { url, email, query, cleanQuery });

      // استخدام usegetdata
      const res = await usegetdata(url);

      console.log('✅ API Response:', res);

      if (!res || !res.success) {
        console.error('❌ API returned error or no success:', res);
        throw new Error(res?.message || 'فشل في جلب البيانات');
      }

      dispatch({
        type: Get_All_Leads_For_TeamLeader_By_TeamLeader_Email,
        payload: res,
      });
    } catch (e) {
      console.error('❌ API Error:', e);
      dispatch({
        type: Get_Error,
        payload: e.message + ' error',
      });
    }
  };

//get all data managers with Managers email from Sales managers Field action

export const GetallLeads_data_By_Managers_Email = (email, query) => async (dispatch) => {
  try {
    // تنظيف الـ query من معلمة email إذا كانت موجودة
    let cleanQuery = query || '';

    // إزالة أي معلمة email من query string
    if (cleanQuery.includes('email=')) {
      const queryParams = new URLSearchParams(cleanQuery);
      queryParams.delete('email');
      cleanQuery = queryParams.toString();
    }

    // 🔥 بناء URL متكامل
    let url = `api/v1/users/managers-leads?email=${encodeURIComponent(email)}`;

    // إضافة الـ query إذا كان موجوداً
    if (cleanQuery && cleanQuery.trim() !== '') {
      url += `&${cleanQuery}`;
    }

    console.log('🌐 API Request URL:', url);
    console.log('📧 Email being sent:', email);
    console.log('🔍 Clean Query:', cleanQuery);

    // استخدام usegetdata
    const res = await usegetdata(url);

    console.log('✅ API Response:', res);

    if (!res || !res.success) {
      console.error('❌ API returned error or no success:', res);
      throw new Error(res?.message || 'فشل في جلب البيانات');
    }

    dispatch({
      type: Get_All_Leads_For_Managers_By_Managers_Email,
      payload: res,
    });

    return res; // 🔥 مهم لإرجاع النتيجة
  } catch (e) {
    console.error('❌ API Error:', e);
    dispatch({
      type: Get_Error,
      payload: e.message + ' error',
    });
    throw e; // 🔥 إعادة رمي الخطأ
  }
};

export const GetallLeads_data_By_Managers_Email_CRM_DATA = (email, query) => async (dispatch) => {
  try {
    // تنظيف الـ query من معلمة email إذا كانت موجودة
    let cleanQuery = query || '';

    // إزالة أي معلمة email من query string
    if (cleanQuery.includes('email=')) {
      const queryParams = new URLSearchParams(cleanQuery);
      queryParams.delete('email');
      cleanQuery = queryParams.toString();
    }

    // 🔥 بناء URL متكامل
    let url = `api/v1/users/managers-leads-crm-data?email=${encodeURIComponent(email)}`;

    // إضافة الـ query إذا كان موجوداً
    if (cleanQuery && cleanQuery.trim() !== '') {
      url += `&${cleanQuery}`;
    }

    console.log('🌐 API Request URL:', url);
    console.log('📧 Email being sent:', email);
    console.log('🔍 Clean Query:', cleanQuery);

    // استخدام usegetdata
    const res = await usegetdata(url);

    console.log('✅ API Response:', res);

    if (!res || !res.success) {
      console.error('❌ API returned error or no success:', res);
      throw new Error(res?.message || 'فشل في جلب البيانات');
    }

    dispatch({
      type: Get_All_Leads_For_Managers_By_Managers_Email_CRM_DATA,
      payload: res,
    });

    return res; // 🔥 مهم لإرجاع النتيجة
  } catch (e) {
    console.error('❌ API Error:', e);
    dispatch({
      type: Get_Error,
      payload: e.message + ' error',
    });
    throw e; // 🔥 إعادة رمي الخطأ
  }
};

// get all Mangers
export const Getall_data_user_log_Mangers = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Signup?role=Manager&role=Admin`);

    dispatch({
      type: Get_All_Sales_Managers_By_Email,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};

// أكشن إضافة كومنت للمرحله (Meeting, EOI, Done Deal)
export const AddStageCommentAction = (leadId, stageId, commentData) => async (dispatch) => {
  try {
    // ✅ استخدام useinsertdatawithoutimage لإرسال البيانات
    const res = await useinsertdatawithoutimage(
      `/api/v1/Meetingcomments/${leadId}/stage/${stageId}`, // ✅ أضفنا /stage/ في النص
      commentData,
    );

    // ✅ إرسال الأكشن مع البيانات
    dispatch({
      type: AddMeetingComment_Type, // أو الـ type اللي انت عايزه
      payload: res.data,
    });

    // ✅ إرجاع النتيجة عشان نستخدمها في الكومبوننت
    return res;
  } catch (error) {
    console.error('Error adding stage comment:', error);

    // ✅ إرسال أكشن الخطأ
    dispatch({
      type: Get_Error,
      payload: error.response?.data || error.message,
    });

    // ✅ رمي الخطأ عشان نمسكه في الكومبوننت
    throw error;
  }
};
